app.service('productArchive', function(productCardConfig, modal) {
	var $self, $recommendedList, $compareButton, $products;


	function setElements(html) {
		$self=$('#product-archive');
		$recommendedList = $("#recommended-products-container", $self);
		$compareButton = $(".js-compare-products", $self);
		$recommendedList.html(html);
		$products = $('.product-archive',$recommendedList);
	}

	function setEvents() {
	}

	function setHeaderHeight() {
		$self.removeClass('extended-header');

		$products.each(function(i,element){
			if($(element).find('.product-header').height() >= 60){
				$self.addClass('extended-header');
			}
		});
	}

	function setPriceHeight() {
		var $prices=$products.find('.product-price');
		var height=0;
		$prices.each(function(){
			height=Math.max(height, $(this).height());
		});

		$prices.height(height);
	}
	function loadRecomendedSuccess(html){
		setElements(html);
		setEvents();
		setHeaderHeight();
		setPriceHeight();
		setCompareLink();
	}
	function setCompareLink(){
		var linkHref = '/porownanie.bhtml?';
		var $products=$('.product-archive',$self);
		if($products.length>1){
			$products.each(function(i, el) {
				if(i<3){
					linkHref += (i>0?"&":"") + 'p' + (i+1) +'=' + $(this).data('product-id');
				}
			});

			$self.addClass('products-loaded');
			$compareButton.attr('href', linkHref);
		}
	}

	function loadRecomended() {
		$.ajax({
			url: '/not-active-recommended-products.ltr',
			type: "POST",
			data: {
				id: productCardConfig.getData().id
			},
			success: function(data) {
				loadRecomendedSuccess(data);
			},
			error: function() {
				modal.alert('Błąd odczytu rekomendacji produktów archiwalnych/nieaktywnych');
			}
		});
	}

	function init() {
		setElements();
		loadRecomended();
	}

	return {
		init:init
	};
});
